import React from "react";
import { toYmd, ymdToDate } from '../utils/dateOnly';
import { useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";

const CustomerDialog = ({
    visible,
    onHide,
    customer,
    handleChange,
    handleSubmit,
    isReadOnly,
    isRequired,
    dialogName,
    titles,
    segments,
    categories,
    priority,
    status
    }) => { 

    const handleCancel = (event) => {
        event.preventDefault(); 
        onHide();
    };   

    const inputRef = useRef(null);
    
    useEffect(() => {
        if (visible) {
        setTimeout(() => inputRef.current?.focus(), 500); // Ensures it runs after rendering
        }
    }, [visible]);
     
    return (
            <Dialog
                header={dialogName}
                visible={visible}
                onHide={onHide}
                modal
                style={{ width: '40rem', borderRadius: '12px', padding: '.5rem' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                className="p-fluid"
            >
                <form id="dialogForm" onSubmit={handleSubmit}>
                    <div style={{ borderRadius: '12px', padding: '1rem' }}>
                        <div className="field">
                            <label htmlFor="phone_number" className="font-bold">Phone Number:</label>
                            <InputText
                                id="phone_number"
                                ref={inputRef}
                                value={customer.phone_number}
                                onChange={(e) => handleChange(e, "phone_number")}
                                placeholder="Enter Phone Number"
                                required={isRequired}
                                readOnly={isReadOnly}
                            />
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                            <label className="font-bold">Gender:</label>
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="genderMale"
                                    name="gender"
                                    value="M"
                                    onChange={(e) => handleChange(e, "gender")}
                                    checked={customer.gender === "M"}
                                    disabled={isReadOnly}
                                />
                                <label htmlFor="genderMale" className="ml-2">Male</label>

                                <RadioButton
                                    inputId="genderFemale"
                                    name="gender"
                                    value="F"
                                    onChange={(e) => handleChange(e, "gender")}
                                    checked={customer.gender === "F"}
                                    className="ml-4"
                                    disabled={isReadOnly}
                                />
                                <label htmlFor="genderFemale" className="ml-2">Female</label>
                            </div>
                            </div>
                        <div className="field col">
                            <label htmlFor="title" className="font-bold">Title:</label>
                            <Dropdown
                                id="title"
                                value={customer.title}
                                options={titles}
                                onChange={(e) => handleChange(e, "title")}
                                placeholder="Select Title"
                                required
                                disabled={isReadOnly}
                            />
                        </div></div>
                        <div className="formgrid grid">
                        <div className="field col">
                            <label htmlFor="first_name" className="font-bold">First Name:</label>
                            <InputText
                                id="first_name"
                                value={customer.first_name}
                                onChange={(e) => handleChange(e, "first_name")}
                                placeholder="Enter First Name"
                                readOnly={isReadOnly}
                            />
                        </div>
                        <div className="field col">
                            <label htmlFor="last_name" className="font-bold">Last Name:</label>
                            <InputText
                                id="last_name"
                                value={customer.last_name}
                                onChange={(e) => handleChange(e, "last_name")}
                                placeholder="Enter Last Name"
                                required
                                readOnly={isReadOnly}
                            />
                        </div>
                        </div>
                        <div className="field">
                            <label htmlFor="email" className="font-bold">Email:</label>
                            <InputText
                                id="email"
                                value={customer.email}
                                onChange={(e) => handleChange(e, "email")}
                                placeholder="Enter Email"
                                readOnly={isReadOnly}
                            />
                        </div>
                        <div className="field">
                            <label className="font-bold" htmlFor="loyalty_discount_percent">Loyalty Discount %</label>
                            <InputNumber
                                id="loyalty_discount_percent"
                                value={customer.loyalty_discount_percent ?? 0}
                                onValueChange={(e) => handleChange(e, "loyalty_discount_percent")}
                                min={0}
                                max={100}
                                mode="decimal"
                                minFractionDigits={0}
                                maxFractionDigits={2}
                                showButtons
                            />
                        </div>
                        <div className="field">
                            <label htmlFor="address" className="font-bold">Address:</label>
                            <InputText
                                id="address"
                                value={customer.address}
                                onChange={(e) => handleChange(e, "address")}
                                placeholder="Enter Address"
                                readOnly={isReadOnly}
                            />
                        </div>
                        <div className="formgrid grid">
                        <div className="field col">
                            <label htmlFor="nic" className="font-bold">NIC:</label>
                            <InputText
                                id="nic"
                                value={customer.nic}
                                onChange={(e) => handleChange(e, "nic")}
                                placeholder="Enter NIC"
                                readOnly={isReadOnly}
                            />
                        </div>
                        <div className="field col">
                            <label htmlFor="passport" className="font-bold">Passport:</label>
                            <InputText
                                id="passport"
                                value={customer.passport}
                                onChange={(e) => handleChange(e, "passport")}
                                placeholder="Enter Passport"
                                readOnly={isReadOnly}
                            />
                        </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="dob" className="font-bold">Date of Birth:</label>
                                <Calendar
                                    id="dob"
                                    value={customer.dob ? ymdToDate(toYmd(customer.dob)) : null}
                                    onChange={(e) => handleChange(e, "dob")}
                                    placeholder="Select Date of Birth"
                                    disabled={isReadOnly}
                                    showIcon
                                />
                            </div>
                            <div className="field col">
                                <label htmlFor="loyalty" className="font-bold">Loyalty:</label>
                                <InputText
                                    id="loyalty"
                                    value={customer.loyalty}
                                    onChange={(e) => handleChange(e, "loyalty")}
                                    placeholder="Enter Loyalty Program"
                                    readOnly={isReadOnly}
                                />
                            </div>
                            </div>
                            <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="category" className="font-bold">Category:</label>
                                <Dropdown
                                    id="category"
                                    value={customer.category}
                                    options={categories}
                                    onChange={(e) => handleChange(e, "category")}
                                    placeholder="Select Category"
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="field col">
                                <label htmlFor="segment" className="font-bold">Segment:</label>
                                <Dropdown
                                    id="segment"
                                    value={customer.segment}
                                    options={segments}
                                    onChange={(e) => handleChange(e, "segment")}
                                    placeholder="Select Segment"
                                    disabled={isReadOnly}
                                />
                            </div>
                            </div>
                            <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="priority" className="font-bold">Priority:</label>
                                <Dropdown
                                    id="priority"
                                    value={customer.priority}
                                    options={priority}
                                    onChange={(e) => handleChange(e, "priority")}
                                    placeholder="Select Priority"
                                    disabled={isReadOnly}
                                />
                            </div>
                            <div className="field col">
                                <label htmlFor="status" className="font-bold">Status:</label>
                                <Dropdown
                                    id="status"
                                    value={customer.status}
                                    options={status}
                                    onChange={(e) => handleChange(e, "status")}
                                    placeholder="Select Status"
                                    disabled={isReadOnly}
                                />
                            </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                            <Button label="Save" icon="pi pi-check" form="dialogForm" type="submit" style={{borderRadius:"6px", maxWidth: "120px"}} disabled={isReadOnly}/>
                            <Button label="Cancel" icon="pi pi-times" outlined onClick={handleCancel}  style={{borderRadius:"6px", maxWidth: "120px"}} />
                        </div>      
                </form>
            </Dialog>
        );
    };
    
export default CustomerDialog;  